import { useState } from "react";
import "./Guestbook.css";
import GuestbookForm from "./GuestbookForm";
import Comment from "./Comment";
import { deletePost } from "./deletePost";
import { banUser } from "./banUser";
import { makeCSRFRequest } from "../../utils/csrf";
import { BASE_URL } from "../../App";

export default function GuestbookList(props) {
  const [writeComment, setWriteComment] = useState({});
  const [showComments, setShowComments] = useState({});
  const [modifyPost, setModifyPost] = useState(false);
  const [tempMessage, setTempMessage] = useState("");

  const handleDelete = async (id, parentPostId = null) => {
    const postId = parseInt(id);
    const userId = parseInt(localStorage.getItem("minebikers_userId"));
    if (isNaN(postId)) {
      console.error("Invalid post ID:", postId);
      return;
    }
    if (!userId && !props.member) {
      console.error("User ID is not defined or no member status");
      return;
    }
    const confirmDelete = window.confirm("Haluatko varmasti poistaa viestin?");
    if (!confirmDelete) {
      return;
    }
    const isDeleted = await deletePost(postId, userId, props.isMember);
    if (isDeleted) {
      if (parentPostId) {
        await props.refreshComments(parentPostId);
        await props.refreshParent(parentPostId);
      }
      await props.refreshPosts();
    }
  };

  const handleBanUser = async (name, bannedStatus) => {
    try {
      const userId = parseInt(localStorage.getItem("minebikers_userId"));
      const result = await banUser(name, !bannedStatus, userId);
      if (result) {
        alert(
          bannedStatus
            ? `Käyttäjä ${name} laitettu arestiin`
            : `Käyttäjän ${name} aresti peruttu`
        );
      }
      await props.refreshPosts();

      const updatedComments = { ...props.comments };
      Object.keys(updatedComments).forEach((postId) => {
        updatedComments[postId] = updatedComments[postId].map((comment) => {
          if (comment.nimi === name) {
            return { ...comment, ihminen: !bannedStatus };
          }
          return comment;
        });
      });
      props.setComments(updatedComments);
    } catch (error) {
      console.error("Virhe käyttäjän bannauksessa:", error);
      alert("Virhe käyttäjän bannauksessa");
    }
  };

  const handleModify = async (postId, initialMessage) => {
    setModifyPost((prevState) => ({
      ...prevState,
      [postId]: !prevState[postId],
    }));
    setTempMessage(initialMessage);
  };

  const handleSaveModify = async (
    postId,
    updatedMessage,
    parentPostId = null
  ) => {
    const userId = parseInt(localStorage.getItem("minebikers_userId"));
    const token = localStorage.getItem("minebikers_token");
    if (!updatedMessage || updatedMessage.trim() === "") {
      alert("Viesti ei voi olla tyhjä");
      return;
    }

    try {
      const response = await makeCSRFRequest(
        `${BASE_URL}/vieraskirja/messages/${postId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ viesti: updatedMessage, userId: userId }),
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.banned) {
          alert("OLET ARESTISSA");
          window.location.reload();
          return { error: "banned" };
        }
      }
      setModifyPost((prevState) => ({
        ...prevState,
        [postId]: false,
      }));
      if (!response.ok) {
        console.error("Virhe viestin päivityksessä:", response.statusText);
        return;
      }
      if (parentPostId) {
        await props.refreshComments(parentPostId);
      } else {
        props.refreshPosts();
      }
    } catch (error) {
      console.error("Virhe viestin päivityksessä:", error);
    }
  };

  const handleWriteComment = async (postId) => {
    setWriteComment((prevState) => ({
      ...prevState,
      [postId]: !prevState[postId],
    }));
  };

  const handleOpenComments = async (postId) => {
    setShowComments((prev) => ({
      ...prev,
      [postId]: !prev[postId],
    }));
    if (
      !showComments[postId] &&
      (!props.comments[postId] || props.comments[postId].length === 0)
    ) {
      await props.refreshComments(postId);
    }
  };

  return (
    <div style={{ marginTop: "7%", marginBottom: "25%" }}>
      {props.messagesLoading ? (
        <div>
          <h1 style={{ color: "gray", background: "black" }}>
            Ladataan viestejä...
          </h1>
        </div>
      ) : props.messages.length === 0 ? (
        <div>
          <h1 style={{ color: "gray", background: "black" }}>Ei viestejä</h1>
        </div>
      ) : (
        props.messages.map((message) => (
          <div className="viesti" key={message.id}>
            <div>
              <h2> {message.nimi}</h2>
            </div>
            <div>
              {!modifyPost[message.id] ? (
                <h3>{message.viesti}</h3>
              ) : (
                <div>
                  <div>
                    <textarea
                      rows={10}
                      defaultValue={message.viesti}
                      onChange={(e) => setTempMessage(e.target.value)}
                    />
                  </div>
                  <div>
                    <button
                      onClick={() => handleSaveModify(message.id, tempMessage)}
                    >
                      Tallenna
                    </button>
                    <button onClick={() => handleModify(message.id)}>
                      Peruuta
                    </button>
                  </div>
                </div>
              )}

              {message.nimi === props.nickname &&
              props.isHuman &&
              !modifyPost[message.id] ? (
                <>
                  <button onClick={() => handleDelete(message.id)}>
                    Poista
                  </button>
                  <button onClick={() => handleModify(message.id)}>
                    Muokkaa
                  </button>
                </>
              ) : props.isMember && props.isHuman && !modifyPost[message.id] ? (
                <div>
                  <button onClick={() => handleDelete(message.id)}>
                    Poista
                  </button>

                  {message.ihminen ? (
                    <button
                      onClick={() =>
                        handleBanUser(message.nimi, message.ihminen)
                      }
                    >
                      Laita käyttäjä arestiin
                    </button>
                  ) : (
                    <button
                      onClick={() =>
                        handleBanUser(message.nimi, message.ihminen)
                      }
                    >
                      Poista aresti
                    </button>
                  )}
                </div>
              ) : null}

              <p style={{ color: "gray" }}>
                Lähetetty: {new Date(message.aika).toLocaleString()}
              </p>
              {message.muokattu !== null ? (
                <p>Muokattu: {new Date(message.muokattu).toLocaleString()}</p>
              ) : (
                ""
              )}
            </div>

            {!writeComment[message.id] ? (
              <div>
                <button onClick={() => handleWriteComment(message.id)}>
                  Kommentoi
                </button>
                {message.kommentit > 0 ? (
                  <button onClick={() => handleOpenComments(message.id)}>
                    Kommentit: {message.kommentit}
                  </button>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <div>
                <GuestbookForm
                  refreshPosts={props.refreshPosts}
                  refreshComments={props.refreshComments}
                  refreshParent={props.refreshParent}
                  userId={props.userId}
                  setUserId={props.setUserId}
                  nickname={props.nickname}
                  setNickname={props.setNickname}
                  saveUserId={props.saveUserId}
                  saveUserName={props.saveUserName}
                  saveUserToken={props.saveUserToken}
                  savedToken={localStorage.getItem("minebikers_token")}
                  linkitys={message.id}
                  isHuman={props.isHuman}
                  isMember={props.isMember}
                  onCommentSubmit={() => {
                    handleWriteComment(message.id);
                    setShowComments((prev) => ({
                      ...prev,
                      [message.id]: true,
                    }));
                  }}
                />
                <button onClick={() => handleWriteComment(message.id)}>
                  Sulje
                </button>
              </div>
            )}

            {showComments[message.id] && props.comments[message.id] && (
              <div>
                {props.comments[message.id].length > 0
                  ? props.comments[message.id].map((comment) => (
                      <Comment
                        key={comment.id}
                        comment={comment}
                        nickname={props.nickname}
                        isMember={props.isMember}
                        isHuman={props.isHuman}
                        userId={props.userId}
                        setUserId={props.setUserId}
                        setNickname={props.setNickname}
                        saveUserId={props.saveUserId}
                        saveUserName={props.saveUserName}
                        saveUserToken={props.saveUserToken}
                        savedToken={localStorage.getItem("minebikers_token")}
                        refreshPosts={props.refreshPosts}
                        refreshComments={props.refreshComments}
                        refreshParent={props.refreshParent}
                        handleDelete={handleDelete}
                        handleModify={handleModify}
                        handleSaveModify={handleSaveModify}
                        modifyPost={modifyPost}
                        setModifyPost={setModifyPost}
                        handleBanUser={handleBanUser}
                        handleWriteComment={handleWriteComment}
                        handleOpenComments={handleOpenComments}
                        writeComment={writeComment}
                        showComments={showComments}
                        setShowComments={setShowComments}
                        comments={props.comments}
                        tempMessage={tempMessage}
                        setTempMessage={setTempMessage}
                        onCommentSubmit={() => {
                          handleWriteComment(message.id);
                          setShowComments((prev) => ({
                            ...prev,
                            [message.id]: true,
                          }));
                        }}
                      />
                    ))
                  : ""}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}
